module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920-b3cfa0dcbe170caa3694320280539449.webp";